<div class="container">
  <mat-card>
    <form [formGroup]="editGroupForm">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (editGroupForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Group Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
            @if (editGroupForm.controls.name.hasError('pattern')) {
              <mat-error>
                {{ 'labels.inputs.Group Name' | translate }} <strong>{{ 'labels.inputs.cannot' | translate }}</strong>
                {{ 'labels.commons.begin with a special character or number' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Staff' | translate }}</mat-label>
            <mat-select formControlName="staffId">
              @for (staff of staffData; track staff) {
                <mat-option [value]="staff.id">
                  {{ staff.displayName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field (click)="submittedOnDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Submitted On' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="submittedOnDatePicker"
              required
              formControlName="submittedOnDate"
            />
            <mat-datepicker-toggle matSuffix [for]="submittedOnDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #submittedOnDatePicker></mat-datepicker>
            @if (editGroupForm.controls.submittedOnDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Submission Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          @if (this.editGroupForm.contains('activationDate')) {
            <mat-form-field (click)="activationDatePicker.open()">
              <mat-label>{{ 'labels.inputs.Activation Date' | translate }}</mat-label>
              <input
                matInput
                [min]="editGroupForm.value.submittedOnDate"
                [max]="maxDate"
                [matDatepicker]="activationDatePicker"
                required
                formControlName="activationDate"
              />
              <mat-datepicker-toggle matSuffix [for]="activationDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #activationDatePicker></mat-datepicker>
              @if (editGroupForm.controls.activationDate.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Activation Date' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.External id' | translate }}</mat-label>
            <input matInput formControlName="externalId" />
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!editGroupForm.valid" (click)="submit()">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
